/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  if($(".project-results-graphs").length > 0) {
    showToolTipOnChartLegendHover('projects_area_chart');
    builtUpAreaTotal();
    showToolTipOnChartLegendHover('projects_budget_chart');
    budgetTotal();
    return redrawPieChartTotalOnWindowReset();
  }
});

if (!window.Monaqasat) { window.Monaqasat = {}; }
make_taggable();
Monaqasat.Utils = {
  resetForm(form) {
    $(form).find('input:text, input:password, input:file, select, textarea').val('');
    return $(form).find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
  }
};

Monaqasat.CompanyProjects = {
  initialize() {
    this.toggleOwnerParticipantRow();
    this.toggleEndDateOnStatus();
    return this.addParticipantOnClick();
  },

  addParticipantOnClick() {
    return $('form').on('click', '.add_fields', function(event) {
      const time = new Date().getTime();
      const regexp = new RegExp($(this).data('id'), 'g');
      $(this).before($(this).data('fields').replace(regexp, time));
      return event.preventDefault();
    });
  },

  toggleEndDateOnStatus() {
    if ($('#project_status').val() === "") {
      $('#project_started_at').prop('disabled', true);
      $("span#started_at").addClass("disabled");
      $('#project_ended_at').prop('disabled', true);
      $("span#ended_at").addClass("disabled");
    }
    return $('#project_status').change(function(e) {
      const status = $(this).val();
      if (status === "") {
        $('#project_started_at').prop('disabled', true);
        $("span#started_at").addClass("disabled");
        $('#project_ended_at').prop('disabled', true);
        return $("span#ended_at").addClass("disabled");
      } else {
        $('#project_started_at').prop('disabled', false);
        $("span#started_at").removeClass("disabled");
        $('#project_ended_at').prop('disabled', false);
        return $("span#ended_at").removeClass("disabled");
      }
    });
  },

  toggleOwnerParticipantRow() {
    const creatorRole = $('.creator_project_participant_role').val();

    if ((creatorRole !== 'owner') || (creatorRole !== '')) {
      $('#owner-row').show();
    }

    return $('.creator_project_participant_role').change(function(e) {
      const role = $(this).val();

      if ((role !== 'owner') && (role !== '')) {
        return $('#owner-row').show();
      } else if ((role === 'owner') || (role === '')) {
        $('#owner-row').hide();
        return Monaqasat.Utils.resetForm('#owner-row');
      }
    });
  }
};


Monaqasat.ParticipantConfirmationManager = class ParticipantConfirmationManager {
  constructor() {
    this.showDenialForm = this.showDenialForm.bind(this);
    this.showApprovalForm = this.showApprovalForm.bind(this);
    this.initialParticipationQuestion    = $("#initial-participation-question"); // asks if company participated
    this.companyParticipationAffirmation = $("#affirm_company_participation");
    this.companyParticipationDenial      = $("#deny_company_participation");

    this.approvalConfirmationForm        = $("#approval-confirmation-form");     // asks if info is correct. thank you gets show via ajax
    this.verificationDenialButton        = $("#verification-denial-button");
    this.denialForm                      = $("#denial-confirmation-form");

    this.denialConfirmationForm          = $("#denial-confirmation-form");       // asks why info was wrong

    this.companyParticipationAffirmation.on("click", e => {
      e.preventDefault();
      return this.showApprovalForm();
    });

    this.companyParticipationDenial.on("click", e => {
      e.preventDefault();
      return this.showDenialForm();
    });

    this.verificationDenialButton.on("click", e => {
      e.preventDefault();
      return this.showDenialForm();
    });
  }

  showDenialForm() {
    this.initialParticipationQuestion.hide();
    this.approvalConfirmationForm.hide();
    return this.denialForm.show();
  }

  showApprovalForm() {
    this.initialParticipationQuestion.hide();
    return this.approvalConfirmationForm.show();
  }
};

$(document).ready(function() {
  setup_cp_gridview();
  if ($('#project_participant_description').length > 0) {
    $('#project_participant_description').simplyCountable({
      counter: '#description_counter',
      maxCount: 1500,
      countDirection: 'up',
      strictMax: true
    });
  }

  setTimeout(function() {
    $('#company-projects-grid').css('opacity', 200);
  });

  new Monaqasat.ParticipantConfirmationManager();

  Monaqasat.CompanyProjects.initialize();
  $(document).on("focus", ".participant-row input[id*='company_name']", function() {
    $(this).autocomplete({
      source: $(this).data('autocomplete-source'),
      minLength: 2,
      delay: 300,
      select( event, object ) {
        if (object.item.value !== null) {
          $(event.target).closest(".participant-row").find("input[id*='email']").attr("disabled", true);
          $(event.target).closest(".participant-row").find("input[id*='email']").parent().hide();
          return $(event.target).closest(".participant-row").find("input[id*='email']").parent().siblings('.right-collapse').eq(-1).hide();
        } else {
          $(event.target).closest(".participant-row").find("input[id*='email']").removeAttr("disabled");
          $(event.target).closest(".participant-row").find("input[id*='email']").parent().show();
          return $(event.target).closest(".participant-row").find("input[id*='email']").parent().siblings('.right-collapse').eq(-1).show();
        }
      }
    });

    //Bindings for Company Name field
    return $(this).on('keyup', function() {
      if ($(this).val() === "") {
        if (($(this).closest(".participant-row").find("select[id*='role']").attr("data-parsley-required") !== undefined) && ($(this).closest(".participant-row").find("select[id*='role']").attr("data-parsley-required") !== "false")) {
          $('form.data-parsley-validate').parsley().destroy();
          $(this).closest(".participant-row").find("select[id*='role']").attr('data-parsley-required', 'false');
          $(this).closest(".participant-row").find("input[id*='email']").attr('data-parsley-required', 'false');
          $(this).closest(".participant-row").find("input[id*='email']").removeAttr("disabled");
          $(this).closest(".participant-row").find("input[id*='email']").parent().show();
          $(this).closest(".participant-row").find("input[id*='email']").parent().siblings('.right-collapse').eq(-1).show();
          return $('form.data-parsley-validate').parsley({'excluded': ':disabled'});
        }
      } else {
        if (($(this).closest(".participant-row").find("select[id*='role']").attr("data-parsley-required") === undefined) || ($(this).closest(".participant-row").find("select[id*='role']").attr("data-parsley-required") === "false")) {
          $('form.data-parsley-validate').parsley().destroy();
          $(this).closest(".participant-row").find("select[id*='role']").attr('data-parsley-required', 'true');

          if (!$(this).closest(".participant-row").find("input[id*='email']").is(':disabled')) {
            $(this).closest(".participant-row").find("input[id*='email']").attr('data-parsley-required', 'true');
          }

          return $('form.data-parsley-validate').parsley({'excluded': ':disabled'});
        }
      }
    });
  });

  //Bindings for Email field
  $(document).on("focus", ".participant-row input[id*='email']", function() {
    return $(this).on('keyup', function() {
      return validateCompanyField(this, $(this).closest(".participant-row").find("select[id*='role']"));
    });
  });

  //Bindings for Role Dropdown field
  $(document).on("focus", ".participant-row select[id*='role']", function() {
    return $(this).on('change', function() {
      return validateCompanyField(this, $(this).closest(".participant-row").find("input[id*='email']"));
    });
  });

  //select2 for construction_types
  $("#project_construction_types").select2({
    placeholder: I18n.t("projects.prompt.construction_types", {defaults: [{message: "Select Category"}]}),
    width: "100%"
  },
    $(this).on('change', () => $('.project_construction_types').find(".select2-search-field input").val(''))
  );

  //Event calling to enable validation for already existed fields
  $(".participant-row select[id*='role']").focus();
  $(".participant-row select[id*='role']").change();

  $(".participant-row input[id*='company_name']").focus();
  $(".participant-row input[id*='company_name']").keyup();

  $(".participant-row input[id*='email']").focus();
  $(".participant-row input[id*='email']").keyup();

  $("form #project_title").focus();

  if ($("#project_budget").val() === "0.00") {
    return $("#project_budget").val("");
  }
});


var validateCompanyField = function( object, sibling_obj ) {
  if (($(object).val() === "") && ($(sibling_obj).val() === "")) {
    if (($(object).closest(".participant-row").find("input[id*='company_name']").attr("data-parsley-required") !== undefined) && ($(object).closest(".participant-row").find("input[id*='company_name']").attr("data-parsley-required") !== "false")) {
      $('form.data-parsley-validate').parsley().destroy();
      $(object).closest(".participant-row").find("input[id*='company_name']").attr('data-parsley-required', 'false');
      return $('form.data-parsley-validate').parsley({'excluded': ':disabled'});
    }
  } else {
    if ((($(object).closest(".participant-row").find("input[id*='company_name']").attr("data-parsley-required") === undefined) || ($(object).closest(".participant-row").find("input[id*='company_name']").attr("data-parsley-required") === "false")) && ( ($(object).closest('#owner-row').length <= 0) || !$('#owner-row').is(':hidden'))) {
      $('form.data-parsley-validate').parsley().destroy();
      $(object).closest(".participant-row").find("input[id*='company_name']").attr('data-parsley-required', 'true');
      return $('form.data-parsley-validate').parsley({'excluded': ':disabled'});
    }
  }
};

const getChartObject = function(chartId) {
  const chartIndex = $(chartId).data('highchartsChart');
  const chart = Highcharts.charts[chartIndex];
  return chart;
};

this.showToolTipOnChartLegendHover = function(id) {
  const chartId = '#' + id;
  const chart = getChartObject(chartId);
  return $(`${chartId} .highcharts-legend span`).each(function(index, element) {
    $(element).hover((function() {
      chart.tooltip.refresh(chart.series[0].data[index]);
    }), function() {
      chart.tooltip.hide();
    });
  });
};

this.builtUpAreaTotal = function() {
  const chart = getChartObject('#projects_area_chart');
  return showTotalInBuaChart(chart, $('#area_chart').data("total"));
};

this.budgetTotal = function() {
  const chart = getChartObject('#projects_budget_chart');
  return showTotalInBudgetChart(chart, $('#budget_chart').data("total"));
};

this.redrawPieChartTotalOnWindowReset = function() {
  const area_chart = $('#projects_area_chart').highcharts();
  $(area_chart).on('redraw', () => builtUpAreaTotal());

  const budget_chart = $('#projects_budget_chart').highcharts();
  return $(budget_chart).on('redraw', () => budgetTotal());
};

var showTotalInBudgetChart = function(chart, total) {

  if (chart.title) {
    chart.title.destroy();
  }
  if (chart.label) {
    chart.label.destroy();
  }
  const r = chart.renderer;
  const x = chart.series[0].center[0] + chart.plotLeft;
  const y = chart.series[0].center[1] + chart.plotTop;
  chart.title = r.text(total, x, y).css({
    color: '#555555',
    fontSize: '20px',
    textAlign: 'center',
    fontFamily: 'Lato',
    fontWeight: 'bold'}).attr({'text-anchor': 'middle'}).add();
  return chart.label = r.label('Total USD', x - 2, y + 2).css({
    color: '#999999',
    fontSize: '13px',
    textAlign: 'center'}).attr({'text-anchor': 'middle'}).add();
};

var showTotalInBuaChart = function(chart, total) {
  if (chart.title) {
    chart.title.destroy();
  }
  if (chart.label) {
    chart.label.destroy();
  }
  const r = chart.renderer;
  const x = chart.series[0].center[0] + chart.plotLeft;
  const y = chart.series[0].center[1] + chart.plotTop;
  chart.title = r.text(total, x, y).css({
    color: '#555555',
    fontSize: '20px',
    textAlign: 'center',
    fontFamily: 'Lato',
    fontWeight: 'bold'}).attr({'text-anchor': 'middle'}).add();
  return chart.label = r.label('Total m<sup>2</sup>', x - 2, y + 2).css({
    color: '#999999',
    fontSize: '13px',
    textAlign: 'center'}).attr({'text-anchor': 'middle'}).add();
};
